import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from './Baseurl/Api.js';


export const loginUser = createAsyncThunk(
  'user/loginUser',
  async (userCredential, { rejectWithValue }) => {
    try {
      const response = await BaseUrl.post('/api/get_user', userCredential);

      const data = response.data.data;

      // Save user info to localStorage
      localStorage.setItem('user', JSON.stringify(data));

      return data;
    } catch (error) {
      // Handle backend errors
      if (error.response && error.response.status === 401) {
        return rejectWithValue('Access denied: invalid credentials');
      }
      return rejectWithValue(error.message);
    }
  }
);

const UserSlice = createSlice({

    name : 'user',
    initialState:{
        loading:false,
        user:null,
        error:null
    },
    extraReducers:(builder)=>{
        builder.addCase(loginUser.pending,(state)=>{
            state.loading = true;
            state.user = null;
            state.error= null;
        })
        .addCase(loginUser.fulfilled,(state,action)=>{
            state.loading = false;
            state.user = action.payload;
            state.error= null;
        })
        .addCase(loginUser.rejected,(state,action)=>{
            state.loading = false;
            state.user = null;
            console.log(action.error);
            if(action.error.message === 'request failed with status code 401'){
                state.error = 'Access denied invalid credentials';
            }
            else{
                state.error = action.error.message;
            }
            state.error= null;
        })
    }
});

export default UserSlice.reducer;